exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* green */ /* new style guide green */ /* Hover green primary button */ /* Disabled green primary button */ /* blue */ /* blue 2 */ /* New style guide blue primary button */ /* Hover blue primary button */ /* Disabled blue primary button */ /* blue 3 */ /* orange */ /* orange 2 */ /* red */ /* red 2 */ /* red 3 */ /* teal */ /* yellow */ /* dark */ /* tan */ /* light brown */ /* brown */ /* dark brown/grey */ /* white */ /* dark */ /* ligher */ /* lightest */ /* black */ /* mid grey cancel/back button */ /* Hover cancel/back button */ /* Disabled cancel/back button */\n\n\n\n", ""]);

// Exports
exports.locals = {
	"grayDark": "#2e3033",
	"grey1": "#C4C4C4",
	"grey2": "#F5F5F5",
	"grey3": "#C2C2C2",
	"grey4": "#272727",
	"grey5": "#747474",
	"grey6": "#F0F0F0",
	"grey7": "#ADADAD",
	"grey8": "#EEEEEE",
	"grey9": "#CECECE",
	"primary1": "#7ca439",
	"primary1b": "#6ea436",
	"primary1c": "#4e7629",
	"primary1d": "#bee095",
	"primary2": "#599daa",
	"primary2b": "#4e7a28",
	"primary2c": "#599daa",
	"primary2d": "#427882",
	"primary2e": "#a0d2db",
	"primary2f": "#3A85C9",
	"primary3": "#ea843d",
	"primary3b": "#F6603C",
	"primary4": "#ea5e3e",
	"primary4b": "#BB4640",
	"primary4c": "#ec5d36",
	"primary5": "#57a98f",
	"primary6": "#FAFA90",
	"sec1": "#53534a",
	"sec2": "#a89f87",
	"sec3": "#7c6e66",
	"sec4": "#5f4f4f",
	"sec5": "#5e4f4f",
	"shade0": "#FFFFFF",
	"shade1": "#65656a",
	"shade2": "#8b8a8d",
	"shade3": "#e4e1dd",
	"shade4": "#f5f2e8",
	"shade5": "#000",
	"shade6": "#8b8a8d",
	"shade7": "#6b696e",
	"shade8": "#c7c6ca",
	"sliderContainerColor": "#374246",
	"sliderSelectionColor": "#80cbc4",
	"sliderBarColor": "#545d62",
	"sliderBarColor2": "#e4e1dd"
};